import { render } from "./ListarProspeccao.vue?vue&type=template&id=0bf29d44&scoped=true"
import script from "./ListarProspeccao.vue?vue&type=script&lang=js"
export * from "./ListarProspeccao.vue?vue&type=script&lang=js"

import "./ListarProspeccao.vue?vue&type=style&index=0&id=0bf29d44&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bf29d44"]])

export default __exports__